import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const MicOffIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      {/* Shorter diagonal slash */}
      <line
        x1="5"
        y1="2"
        x2="20"
        y2="16"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Top right arc (above slash) */}
      <path
        d="M15 9.5V5a3 3 0 0 0-5.6-1.4"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Bottom right arc (below slash) */}
      <path
        d="M9 9.5v2.5a3 3 0 0 0 5.1 2"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Left-side arc (uninterrupted) */}
      <path
        d="M5 10.5v1.5a7 7 0 0 0 12 5"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Right-side arc (above slash) */}
      <path
        d="M18.8 13A7 7 0 0 0 19 12v-1.5"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Mic stand */}
      <line
        x1="12"
        y1="18.75"
        x2="12"
        y2="22"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Horizontal base line */}
      <line
        x1="9"
        y1="22"
        x2="15"
        y2="22"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export default MicOffIcon;
